exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".delivery-tracking-no-items{text-align:center;height:150px}.delivery-tracking-no-items h1{padding:5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/containers/DeliveryTracking/DeliveryTracking.scss
// module id = 746
// module chunks = 5